import apiClient from './axiosClient';
import axios from 'axios';

const API = {
  generateImageUrl: (type = 'ORIGINAL') => apiClient.post('images', { type }),
  upload: (url, data) => axios.put(url, data),
};

export default API;
